import React from 'react';
import moment from 'moment';
import { useFormContext } from 'react-hook-form';
import { Box, Button, Stack, Typography } from '@mui/material';
import { DateRangeWithPeriods, SelectField } from 'components/form';
import { useProposalDealTypes, useProposalStatusesOptions } from 'modules/proposals';

export const PartnerProposalsTableFilters = () => {
  const { isLoading: isDealTypesLoading, options: dealTypesOptions } = useProposalDealTypes();
  const { isLoading: isStatusesLoading, options: statusesOptions } = useProposalStatusesOptions();

  const { control, setValue, reset } = useFormContext();

  const handleResetFilters = () => {
    reset();
  };

  const handleSelectRange = async (range: { endDate: moment.Moment; startDate: moment.Moment }) => {
    setValue('filters.to', range.endDate);
    setValue('filters.from', range.startDate);
  };

  return (
    <Stack>
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="h6" component="span">
          Filters:
        </Typography>

        <Button variant="contained" onClick={handleResetFilters}>
          Reset
        </Button>
      </Stack>

      <Box sx={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: '1rem', alignItems: 'flex-start' }}>
        <DateRangeWithPeriods
          control={control}
          nameTo="filters.to"
          nameFrom="filters.from"
          onRangeChange={handleSelectRange}
        />

        <SelectField
          size="medium"
          label="Status"
          control={control}
          name="filters.status"
          isLoading={isStatusesLoading}
          options={[{ label: 'All', value: 'all' }, ...statusesOptions]}
        />

        <SelectField
          size="medium"
          label="Deal Type"
          control={control}
          name="filters.dealType"
          isLoading={isDealTypesLoading}
          options={[{ label: 'All', value: 'all' }, ...dealTypesOptions]}
        />
      </Box>
    </Stack>
  );
};
